import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { RootState } from "./state/root.store";
import { MapInterfaceStyle } from "./state/sidebar.slice.types";

export const RowFormattedPopover: FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => {
    const { mapInterfaceStyle } = useSelector((s: RootState) => s.sidebarReducer);

    const space = {
        [MapInterfaceStyle.COMPRESSED]: 30,
        [MapInterfaceStyle.SPACIOUS]: 44,
    };

    return <StyledPopover space={space[mapInterfaceStyle]}>{children}</StyledPopover>;
};

const StyledPopover = styled.div<{ space: number }>`
    display: grid;
    grid-auto-rows: ${({ space }) => `${space}px`};
    padding: 0.1rem;
    .title {
        text-align: center;
        align-self: center;
        padding: 0 0.5rem;
    }
    .button {
        padding: 0 2rem;
        display: flex;
        align-items: center;
        position: relative;
        height: 100%;
        #tick {
            position: absolute;
            left: 0.75rem;
        }
        :hover {
            background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.warm};
        }
    }
`;
